import React from 'react'

import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import {Context as AppContext} from '../../contexts/App'
import {Context as NotificationsContext} from '../../contexts/Notifications'

import Box from '@mui/material/Box'
import Paper from "@mui/material/Paper"
import Button from '@mui/material/Button'
import CircularProgress from "@mui/material/CircularProgress"
import DropZone from '../../components/Dropzone'

import config from '../../config.json'

const failedDownloadSnack = 'CreateExternalWarehousingCosts-failedDownloadSnack'
const CreateExternalWarehousingCosts = () => {
  const {vendor} = React.useContext(AppContext)  
  const AmazonSalesChannel = React.useContext(SalesChannelsContext)  
  const { createBulk } = AmazonSalesChannel.externalwarehousingCosts

  const [disabled, setDisabled] = React.useState(false)
  const [clear, setClear] = React.useState(false)
  const [filesAmazon, setAmazonFiles] = React.useState([])
  const [filesMercado, setMercadoFiles] = React.useState([])
  
  const {createSnack, openSnack, deleteSnack} = React.useContext(NotificationsContext)

	React.useEffect(() => {
		createSnack(failedDownloadSnack, {message: "Falló la generación de costos de almacenamiento"})
		return () => deleteSnack(failedDownloadSnack)
	}, [])

	const onError = () => {
		setDisabled(false)
		openSnack(failedDownloadSnack)
	}

  const downloadFile = (url) => {
    console.log("downloading file: ", config.api_url+url)
    window.open(config.api_url+url, "_blank")
    setDisabled(false)
  }
  
  const download = (d) => {
    isNaN(d)? downloadFile(d) : setDisabled(false)
    setClear(true)
  }

  React.useEffect(() => {
    setClear(true)
  }, [vendor])
  
  React.useEffect(() => {
    clear && setClear(false)
  }, [clear])


  const submitFile = e => {
    e.stopPropagation()
    setDisabled(true)
    const data = new FormData()
    const externalwarehousing = vendor == 'amazon'? filesAmazon[0] : filesMercado[0]
    data.append("externalwarehousing", externalwarehousing)
    data.append("vendor", vendor)
    createBulk(data, download, onError)
  }
  
  const amazonFlag = filesAmazon.length > 0
  const mercadoFlag = filesMercado.length > 0

  return (
    <div style={{
      display: 'flex',
      justifyContent: "center",
      margin: 'auto',
      width: 400,
      flexWrap: 'wrap',
    }}>
      <div style={{ width: '100%', float: 'left' }}>
        <h3>Subir costos por almacenamiento</h3> <br />
      </div>
      {vendor && 
        <Paper sx={{ cursor: amazonFlag || mercadoFlag?'auto':'pointer', position: 'relative', minWidth:"200px", minHeight: '200px', display: "flex", justifyContent: "space-around", alignItems: "center", flexDirection: "column",padding: "15px"}}>
            
            <Box sx={{display:vendor=='amazon'?'block':'none'}} >
              <DropZone accept=".csv" setFiles={setAmazonFiles} clear={clear}/>
              <Button disabled={!amazonFlag || disabled} onClick={submitFile} variant="contained" color="primary">
                {disabled?<CircularProgress size={27}/>:'Añadir almacenamiento'}
              </Button>
            </Box>
          
          
            <Box sx={{display:vendor=='mercado'?'block':'none'}}>
              <DropZone accept=".xlsx" setFiles={setMercadoFiles} clear={clear}/>
              <Button disabled={!mercadoFlag || disabled} onClick={submitFile} variant="contained" color="primary">
                {disabled?<CircularProgress size={27}/>:'Añadir almacenamiento'}
              </Button>
            </Box>
          
        </Paper>
      }
    </div>
  )
}

export default CreateExternalWarehousingCosts